import { formFields, listField } from "./config";
import component from "./GustoPayout.vue";

export default {
  component,
  listField,
  formFields,
};

export const selector = (selectedPayoutSystem: string | null): boolean => {
  return selectedPayoutSystem === "gusto";
};
